/**
 * 防拐公益数据服务 - Mock数据
 * 实际对接时替换为API调用
 */

import type { MissingChild, DNACollectionPoint, ChildFilter } from '../types';

// Mock失踪儿童数据
const MOCK_CHILDREN: MissingChild[] = [
  {
    id: 'MCH-2024-00001',
    name: '小明',
    gender: '男',
    birthDate: '2018-05-01',
    missingDate: '2024-01-15',
    missingLocation: '四川省成都市武侯区科华北路',
    province: '四川省',
    city: '成都市',
    currentAge: 6,
    photoUrl: 'https://via.placeholder.com/200x200?text=%E5%B0%8F%E6%98%8E',
    features: '左肩有胎记，会说四川话。失踪时穿蓝色羽绒服，黑色运动裤。',
    contactPhone: '138****8888',
    contactPolice: '成都市公安局武侯分局',
    platform: '宝贝回家',
    createdAt: Date.now() - 86400000 * 30
  },
  {
    id: 'MCH-2024-00002',
    name: '小红',
    gender: '女',
    birthDate: '2019-08-20',
    missingDate: '2024-03-10',
    missingLocation: '广东省广州市天河区天河城',
    province: '广东省',
    city: '广州市',
    currentAge: 5,
    photoUrl: 'https://via.placeholder.com/200x200?text=%E5%B0%8F%E7%BA%A2',
    features: '右耳后有黑痣，扎马尾辫。失踪时穿粉色外套，白色裙子。',
    contactPhone: '139****6666',
    contactPolice: '广州市公安局天河分局',
    platform: '宝贝回家',
    createdAt: Date.now() - 86400000 * 15
  },
  {
    id: 'MCH-2024-00003',
    name: '强强',
    gender: '男',
    birthDate: '2017-03-15',
    missingDate: '2023-11-20',
    missingLocation: '浙江省杭州市西湖区断桥',
    province: '浙江省',
    city: '杭州市',
    currentAge: 7,
    photoUrl: 'https://via.placeholder.com/200x200?text=%E5%BC%BA%E5%BC%BA',
    features: '左腿有烫伤疤痕，嘴唇稍厚。性格活泼，喜欢说话。',
    contactPhone: '158****9999',
    contactPolice: '杭州市公安局西湖分局',
    platform: '团圆系统',
    createdAt: Date.now() - 86400000 * 60
  },
  {
    id: 'MCH-2024-00004',
    name: '婷婷',
    gender: '女',
    birthDate: '2020-01-10',
    missingDate: '2024-04-05',
    missingLocation: '北京市朝阳区北京站',
    province: '北京市',
    city: '北京市',
    currentAge: 4,
    photoUrl: 'https://via.placeholder.com/200x200?text=%E5%A9%AA%E5%A9%AA',
    features: '皮肤白，眼睛大。失踪时穿红色棉袄，提着小灯笼。',
    contactPhone: '136****7777',
    contactPolice: '北京市公安局朝阳分局',
    platform: '宝贝回家',
    createdAt: Date.now() - 86400000 * 7
  },
  {
    id: 'MCH-2024-00005',
    name: '小华',
    gender: '男',
    birthDate: '2016-11-30',
    missingDate: '2023-09-15',
    missingLocation: '江苏省南京市鼓楼区鼓楼公园',
    province: '江苏省',
    city: '南京市',
    currentAge: 8,
    photoUrl: 'https://via.placeholder.com/200x200?text=%E5%B0%8F%E5%8D%8E',
    features: '单眼皮，鼻梁高。失踪时穿校服，背蓝色书包。',
    contactPhone: '137****5555',
    contactPolice: '南京市公安局鼓楼分局',
    platform: '其他',
    createdAt: Date.now() - 86400000 * 120
  },
  {
    id: 'MCH-2024-00006',
    name: '豆豆',
    gender: '男',
    birthDate: '2019-06-25',
    missingDate: '2024-02-14',
    missingLocation: '河南省郑州市二七区火车站',
    province: '河南省',
    city: '郑州市',
    currentAge: 5,
    photoUrl: 'https://via.placeholder.com/200x200?text=%E8%B1%86%E8%B1%86',
    features: '圆脸，双下巴。失踪时穿黄色毛衣，牛仔裤。',
    contactPhone: '135****3333',
    contactPolice: '郑州市公安局二七分局',
    platform: '宝贝回家',
    createdAt: Date.now() - 86400000 * 45
  }
];

// Mock DNA采集点数据
const MOCK_DNA_POINTS: DNACollectionPoint[] = [
  {
    id: 'DNA-51010001',
    name: '成都市公安局DNA采集点',
    address: '四川省成都市青羊区文武路1号',
    phone: '028-8640****',
    latitude: 30.5728,
    longitude: 104.0668,
    province: '四川省',
    city: '成都市',
    serviceHours: '周一至周五 9:00-17:00',
    is24Hour: false,
    requiredDocs: ['身份证', '失踪证明（如有）', '家属照片']
  },
  {
    id: 'DNA-44010001',
    name: '广州市公安局DNA采集点',
    address: '广东省广州市越秀区东风东路658号',
    phone: '020-8311****',
    latitude: 23.1291,
    longitude: 113.2644,
    province: '广东省',
    city: '广州市',
    serviceHours: '周一至周六 8:30-17:30',
    is24Hour: false,
    requiredDocs: ['身份证', '失踪证明', '家属合影照片']
  },
  {
    id: 'DNA-33010001',
    name: '杭州市公安局DNA采集点',
    address: '浙江省杭州市上城区华光路35号',
    phone: '0571-8728****',
    latitude: 30.2741,
    longitude: 120.1551,
    province: '浙江省',
    city: '杭州市',
    serviceHours: '工作日 9:00-12:00, 14:00-17:00',
    is24Hour: false,
    requiredDocs: ['身份证', '失踪人口登记表']
  },
  {
    id: 'DNA-11000001',
    name: '北京市公安局DNA采集中心',
    address: '北京市东城区前门东大街9号',
    phone: '010-8522****',
    latitude: 39.9042,
    longitude: 116.4074,
    province: '北京市',
    city: '北京市',
    serviceHours: '周一至周五 8:00-16:00',
    is24Hour: false,
    requiredDocs: ['身份证', '失踪证明', '家属血样']
  },
  {
    id: 'DNA-32010001',
    name: '南京市公安局DNA采集点',
    address: '江苏省南京市鼓楼区广州路35号',
    phone: '025-8442****',
    latitude: 32.0603,
    longitude: 118.7969,
    province: '江苏省',
    city: '南京市',
    serviceHours: '周一至周五 9:00-17:00',
    is24Hour: false,
    requiredDocs: ['身份证', '失踪证明']
  },
  {
    id: 'DNA-41010001',
    name: '郑州市公安局DNA采集点',
    address: '河南省郑州市二七区解放路228号',
    phone: '0371-6622****',
    latitude: 34.7466,
    longitude: 113.6253,
    province: '河南省',
    city: '郑州市',
    serviceHours: '全天24小时',
    is24Hour: true,
    requiredDocs: ['身份证', '失踪证明（如有）']
  }
];

/**
 * 获取失踪儿童列表（带筛选）
 */
export async function getMissingChildren(
  filter?: ChildFilter,
  page: number = 1,
  pageSize: number = 20
): Promise<{ total: number; data: MissingChild[] }> {
  // 模拟网络延迟
  await new Promise(resolve => setTimeout(resolve, 500));

  let filtered = [...MOCK_CHILDREN];

  if (filter) {
    if (filter.province) {
      filtered = filtered.filter(c => c.province === filter.province);
    }
    if (filter.city) {
      filtered = filtered.filter(c => c.city === filter.city);
    }
    if (filter.gender) {
      filtered = filtered.filter(c => c.gender === filter.gender);
    }
    if (filter.ageMin !== undefined) {
      filtered = filtered.filter(c => c.currentAge >= filter.ageMin!);
    }
    if (filter.ageMax !== undefined) {
      filtered = filtered.filter(c => c.currentAge <= filter.ageMax!);
    }
    if (filter.keyword) {
      const kw = filter.keyword.toLowerCase();
      filtered = filtered.filter(c =>
        c.name.toLowerCase().includes(kw) ||
        c.features.toLowerCase().includes(kw) ||
        c.missingLocation.toLowerCase().includes(kw)
      );
    }
  }

  // 按时间倒序
  filtered.sort((a, b) => b.createdAt - a.createdAt);

  const total = filtered.length;
  const start = (page - 1) * pageSize;
  const data = filtered.slice(start, start + pageSize);

  return { total, data };
}

/**
 * 获取儿童详情
 */
export async function getMissingChildById(id: string): Promise<MissingChild | null> {
  await new Promise(resolve => setTimeout(resolve, 300));
  return MOCK_CHILDREN.find(c => c.id === id) || null;
}

/**
 * 获取DNA采集点列表
 */
export async function getDNACollectionPoints(): Promise<DNACollectionPoint[]> {
  await new Promise(resolve => setTimeout(resolve, 300));
  return MOCK_DNA_POINTS;
}

/**
 * 获取最近的DNA采集点
 */
export async function getNearbyDNAPoints(
  lat: number,
  lng: number,
  radiusKm: number = 50
): Promise<DNACollectionPoint[]> {
  await new Promise(resolve => setTimeout(resolve, 300));

  const pointsWithDistance = MOCK_DNA_POINTS.map(point => {
    const distance = calculateDistance(lat, lng, point.latitude, point.longitude);
    return { ...point, distance };
  });

  return pointsWithDistance
    .filter(p => p.distance <= radiusKm)
    .sort((a, b) => a.distance - b.distance);
}

/**
 * 计算两点间距离（ Haversine公式）
 */
function calculateDistance(
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
): number {
  const R = 6371; // 地球半径（公里）
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

function toRad(deg: number): number {
  return deg * (Math.PI / 180);
}

/**
 * 获取省份列表
 */
export function getProvinces(): string[] {
  return ['北京市', '广东省', '四川省', '浙江省', '江苏省', '河南省'];
}

/**
 * 格式化距离
 */
export function formatDistance(km: number): string {
  if (km < 1) {
    return `${Math.round(km * 1000)}米`;
  }
  return `${km.toFixed(1)}公里`;
}
